import React from 'react';

import ShareWork from './share_work.wjs';
import { Author } from './types';

type Props = {
  initialSuggestions: { user: Author }[];
  alreadyShared: number[];
  workId: number;
  workTitle: string;

  // the following were added to generalize this modal for use on different pages, in additon to swp
  collectionName: string;
  source: string;

  hideModal: () => void;

  // if given, will be used copied to user's clipboard on copy button press
  // if not given, will assume on the swp and will use the window's location
  workUrl: string;
};

// wrapper around ShareWork so it looks better on a bootstrap modal
export default function ShareWorkModal(props: Props) {
  return (
    <div className="work-card-modal--share-work-wrapper">
      <div className="work-card-modal--share-work-header">
        <button
          className="close work-card-modal--share-work-close-button"
          onClick={props.hideModal}
        >
          <span>×</span>
        </button>
      </div>
      <ShareWork {...props} />
    </div>
  );
}
